import { LANGUAGES, useCourseLanguage } from '@/data/languages';

export const LanguageSwitcher = ({ size = 'sm', testIdPrefix = 'lang-switch' }) => {
  const [lang, setLang] = useCourseLanguage();
  const pad = size === 'lg' ? 'px-5 py-2.5 text-sm' : 'px-3 py-1 text-xs';
  return (
    <div className="inline-flex items-center gap-1 p-1 rounded-full bg-[#0F0F12] border border-white/10" data-testid={`${testIdPrefix}-group`}>
      {LANGUAGES.map((l) => {
        const active = l.id === lang;
        return (
          <button
            key={l.id}
            data-testid={`${testIdPrefix}-${l.id}`}
            onClick={() => setLang(l.id)}
            className={`${pad} rounded-full font-code font-bold transition-colors duration-200 ${active ? 'text-black' : 'text-[#A1A1AA] hover:text-white'}`}
            style={active ? { background: l.color } : undefined}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
};
